import { render, staticRenderFns } from "./qualification-form.vue?vue&type=template&id=6b68bb00&scoped=true"
import script from "./qualification-form.vue?vue&type=script&lang=js"
export * from "./qualification-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68bb00",
  null
  
)

export default component.exports